import React from 'react'
import PersonalInformationComponent from './PersonalInformationComponent'
import Card from '../../../../reusableComponents/cards/Card71'
import Button from '../../../../reusableComponents/buttons/button12'

const PersonalInformation = () => {
    return (
        <div className="w-full">
            <Card
                title='Personal Information'
                showPrimaryButton={true}
                showSecondaryButton={false}
                showSwapComponent1={true}
                showSwapComponent2={false}
                showSwapComponent3={false}
                showDescription={false}
                swapContent1={<PersonalInformationComponent />}
                showMenuButton={false}
                primaryButtonComponent={
                    <Button
                        text="Edit"
                        state="Disabled"
                        onClick={() => { }}
                    />
                }
            />
        </div>
    )
}

export default PersonalInformation